import { Box, Button, Typography } from "@mui/material";
import { NoMessagesIcon } from "../../../assets/icons/MUI/ChatIcons";
import { useState } from "react";
import NewChatPopUp from "../../../shared/NewChatPopUp";
import { useTranslation } from "react-i18next";

const NoMessagesWindow = () => {
  const { t } = useTranslation();

  const [openCreateMessage, setOpenCreateMessage] = useState<boolean>(false);

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "28px",
      }}
    >
      <NoMessagesIcon style={{ width: "160px", height: "120px" }} />
      <Typography variant="body16Regular">{t("pages.chat.noMessagesSendBefore")}</Typography>
      <Typography variant="body16Regular">{t("pages.chat.startYourChatWithYourNetwork")}</Typography>
      <Button variant="primary-sm" onClick={() => setOpenCreateMessage(true)}>
        {t("pages.chat.createNewChat")}
      </Button>
      {openCreateMessage && <NewChatPopUp open={openCreateMessage} handleClose={() => setOpenCreateMessage(false)} />}
    </Box>
  );
};

export default NoMessagesWindow;
